import { inject, type Ref } from "vue";
import { AppContextSymbol } from "./injectionSymbols";

export type AppContext = {
	dark: Ref<boolean>;
	isMobile: Readonly<Ref<boolean>>;
};

export function useAppContext() {
	const ctx = inject(AppContextSymbol);
	if (ctx == null) {
		throw new Error("useAppContext must be used inside the app tree");
	}

	return ctx;
}
